import {
    HttpResponse,
    ArticleModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery} from '@/libs/core/crud/crud-query';
import {CrudService, CrudListResponse, CrudResponse} from '@/libs/core/crud/crud-service';

export class ArticlesDataService implements CrudService<ArticleModel, ArticleModel> {
    
    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error("Method not implemented.");
    }
    
    getGrouped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error("Method not implemented.");
    }
    
    getAll(query: CrudDataQuery<ArticleModel>): Promise<CrudListResponse<ArticleModel>> {
        return ApiService.api.getArticleBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<ArticleModel>> {
        return ApiService.api.getArticleById(id, params);
    }

    create(item: ArticleModel, params?: RequestParams): Promise<CrudResponse<ArticleModel>> {
        return ApiService.api.insertArticle(item, params);
    }

    update(item: ArticleModel, params?: RequestParams): Promise<ArticleModel> {
        return ApiService.api.updateArticle(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<ArticleModel> {
        return ApiService.api.patchArticle(id, patches).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<ArticleModel>): Promise<CrudListResponse<ArticleModel>> {
        return ApiService.api.deleteArticles(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<ArticleModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw "NotImplemented";
    }

}
